<template>
  <main class="mt-3">
  <div class="pl-1 text-center">
    <div class="mb-3 row">
      <div class="container-fluid">
        <h2 class="text-center fw-bold mb-4">
          <u>&nbsp;App Push 전송&nbsp;</u>
        </h2>
        <table class="table table-bordered border-success align-middle w-100 h-auto">
          <tbody>
            <tr style="text-align: center">
              <th class="table-secondary col-2">PUSH 대상</th>
              <td class="col-4">
                <div class="input-group">
                  <select class="form-select form-select-sm" aria-label=".form-select-sm" ref="sel_procCode" v-model="this.reqStatus">
                    <option value="" class="text-danger">발송대상선택</option>
                    <!-- <option value="AL" class="text-danger">회원전체발송</option> -->
                    <option value="PE" class="text-danger">회원개별발송</option>
                  </select>
                </div>
              </td>
              <th class="table-secondary col-2">
                PUSH 대상리스트(회원개별발송)<br>
                <span style="font-size: 0.9rem; color: red;" v-if="this.reqStatus === 'PE'">(최대PUSH: 500건)</span>
              </th>
              <td class="col-4 text-primary">
                <input type="file" class="btn btn-outline-secondary btn-sm" ref="searchExcel" @change="handleFileUpload" :disabled="this.reqStatus !== 'PE'">
              </td>
            </tr>

            <tr style="text-align: center">
              <th class="table-secondary col-md-2" rowspan="3">PUSH 내용</th>
              <td class="col-md-10 text-start" colspan="3">
                <input type="text" class="form-control form-control-sm" placeholder="제목을 입력하세요(20자 이내)" maxlength="20" v-model="puTitle"/>
              </td>
            </tr>
            <tr style="text-align: center">
              <td class="col-md-10" colspan="3">
                <textarea class="form-control" placeholder="전송할 내용 (100자 이내)" ref="notice" id="floatingTextarea" style="height:200px" v-model="puContent" maxlength="100"></textarea>
              </td>
            </tr>
            <tr style="text-align: center">
              <td class="col-md-10" colspan="3">
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" v-model="pushAction" value="A" ref="rbt_salesRoute" checked>
                  <label class="form-check-label text-primary" for="flexRadioDefault1">App열기</label>
                </div>
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" v-model="pushAction" value="L" ref="rbt_salesRoute">
                  <label class="form-check-label text-success" for="flexRadioDefault1">Link열기</label>
                </div>
                <div v-if="pushAction === 'L'">
                  <input type="text" class="form-control form-control-sm" placeholder="URL 255자이내" maxlength="255" v-model="puLink"/>
                </div>
              </td>
            </tr>
            <!-- <tr style="text-align: center">
              <td class="col-md-10" colspan="3">
                <div>이미지(선택사항)</div>
                <div>
                  <input type="file" class="form-control" id="fileSelectorImage" accept="image/jpeg">
                  <div class="alert alert-secondary" role="alert" style="font-size: 0.9rem; text-align: left;">
                    <div>- Image 확장자: jpg/png</div>
                    <div class="text-danger">- Image 크기&nbsp;&nbsp;&nbsp;&nbsp;: 512 x 512px, 1메가 이하</div>
                  </div>
                </div>
              </td>
            </tr> -->

            <tr style="text-align: center">
              <th class="table-secondary" colspan="4">
                <button class="btn btn-warning btn-lg" @click="sendMsg">PUSH전송</button>
              </th>
            </tr>              
          </tbody>
        </table>
      </div>
    </div>
  </div>
  </main>
</template>

<script>
import moment from 'moment';
import * as XLSX from 'xlsx'
import {genCode} from '../assets/js/genCode'
import {insPushHistory_man} from '../assets/js/push'

export default {
  // components: {
  //   DatePicker
  // },
  data() {
    return {
      reqStatus: "",                //발송분류
      excelUpData: [],              //엑셀데이타
      puCode: "",                   //푸시코드
      puTitle: "",                  //푸시제목
      puContent: "",                //푸시내용
      pushAction: "A",              //푸시액션 (A:앱열기, L:링크열기)
      puLink: "",                   //푸시링크
    };
  },
    // 로그인된 사용자만 접근가능페이지
  computed: {
    user() {
      return this.$store.state.user;
    }
  },
  // 생성 시, 상품카테고리 가져온다
  created() {
    // this.getReqProcLevel();
  },
  mounted() {
    // 로그인한 사람이 아니라면 메인화면으로
    if(this.user.handlerGrade > 9 || this.user.handlerGrade == undefined) {
      var swal = require('sweetalert2');
      swal.fire({
        title: '',
        text: '로그인 권한이 없습니다.',
        icon: 'error'
      });
      this.$router.push({path: '/'});
    }

    ////document.getElementById("notice").style.display = "none";
    document.getElementById("user").style.display = "none";

    const today_tmp = moment();
    let today1 = moment([today_tmp.year(), today_tmp.month(), today_tmp.date()]);
    this.today = today1.format("YYYYMMDD")

    // this.generateTimeOptions();
  },

  methods: {
    // mixins에 있는 공통함수 호출샘플
    /** 자릿수 표시 */
    getCurrencyFormat(value) {
      //return this.$currencyFormat(value);
      if(isNaN(value)) 
      { 
        location.reload()
      }
      else
      {
        return this.$currencyFormat(value);
      }      
    },
    /** 개행처리 */
    getStringFormat(text) {
      return this.$stringFormat(text);
    },

    getDateFormat(date)
    {
      return this.$dateFormat(date);
    },

    //pushCode 생성
    async genCode(param) {
      let chkFlag = "N";
      let puCode_tmp = "";

      for (let attempts = 0; attempts < 1000 && chkFlag === "N"; attempts++) 
      {
        puCode_tmp = await genCode(this.$api, param);
        this.puCode = puCode_tmp + "-" + this.today
        //console.log("rtnCode:",rtnCode)

        let chk_genCode = await this.$api("/api/checkDub_puCode", { param: [this.puCode] });

        if (chk_genCode.length > 0) 
        {
          chkFlag = "N";
        } 
        else 
        {
          chkFlag = "Y";
        }
      }

      //console.log("chkFlag:", chkFlag)
      if (chkFlag === "N") 
      {
        this.$swal.fire("","코드생성횟수 한계에 도달하였습니다.<br>담당자에게 문의하여 주세요.","warning")
        return false;
      } 
      else 
      {
        return this.puCode
      }
    },

    handleFileUpload(event) {
      const file = event.target.files[0];

      if(!file) return

      const reader = new FileReader();

      reader.onload = (e) => {
        const data = e.target.result;
        const workbook = XLSX.read(data, { type: 'binary' });
        this.processExcel(workbook);
      };

      reader.readAsBinaryString(file);
    },

    async processExcel(workbook) {
      const firstSheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[firstSheetName];
      let jsonData = XLSX.utils.sheet_to_json(worksheet);

      //console.log("jsonData:",jsonData);

      if(jsonData.length > 499)
      {
        this.$swal.fire("","1회 최대발송인원은 500인입니다", "warning")
        return false
      }
      else
      {
        this.excelUpData = jsonData
        //console.log("excelUpData:", this.excelUpData);

        this.$swal.fire("","인원수와 데이타의 양에 따라 처리시간이 상이합니다<br>종료안내까지 대기해주세요.", "info")
      }
    },

    //푸시발송 api호출+리턴처리
    async sendMsg(){

      if(!this.reqStatus || this.reqStatus == "") 
      {
        this.$swal.fire("", "발송대상이 선택되지 않았습니다.", "warning")
        return false;
      }

      if(this.reqStatus === "PE" && (!this.excelUpData || this.excelUpData.length < 1)) 
      {
        this.$swal.fire("", "발송대상리스트가 없거나, 데이타가 없습니다.", "warning")
        return false;
      }

      if(!this.puTitle || this.puTitle == "") 
      {
        this.$swal.fire("", "PUSH제목이 입력되지 않았습니다.", "warning")
        return false;
      }

      if(!this.puContent || this.puContent == "") 
      {
        this.$swal.fire("", "PUSH내용이 입력되지 않았습니다.", "warning")
        return false;
      }

      if(this.pushAction === "L" && (!this.puLink || this.puLink == "") ) 
      {
        this.$swal.fire("", "연결된 링크정보가 없습니다", "warning")
        return false;
      }

      let mCode = "PU-"
      let mmCode = await this.genCode(mCode)
      this.puCode = mmCode                       //일괄전송구분코드
      // console.log("puCode:", this.puCode, "reqStatus:", this.reqStatus, "pushAction:", this.pushAction)

      
      // 발송처리 진행표시
      let loadingAlert = this.$swal.fire({
        title: '푸시발송 중...',
        html: `<div>총 ${this.excelUpData.length}건 발송 중입니다.</div>`,
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
        }
      });

      let ins_pushHistory_man = await this.$api("/api/ins_pushHistory_man", {param: [ 
        this.puCode, this.reqStatus, this.user.handlerId, this.puTitle, this.puContent, this.puLink
      ]})
      if(ins_pushHistory_man.affectedRows < 1)
      {
        this.$swal.fire("", "푸시이력 등록에 실패하였습니다. 재시도 해주세요.", "warning")
        return false;
      }
      else 
      {
        // push발송처리
        if(this.reqStatus === "AL") 
        {
          //회원전체발송
          let result = await this.push_appPoint('PushAll', 'AL');
          console.log("result:", result);
          
          loadingAlert.close(); // 결과 표시 전에 로딩 닫기

          if(result.success) 
          {
            this.$swal.fire("", "전체 푸시발송이 완료되었습니다.", "success");
          } 
          else 
          {
            this.$swal.fire("", "푸시발송 중 오류가 발생했습니다.", "warning");
          }
        }
        else if(this.reqStatus === "PE") 
        {
          // //회원개별발송
          // for(let j=0; j<this.excelUpData.length; j++) 
          // {
          //   let uId = this.excelUpData[j].userId;   //엑셀업로드시 userId컬럼명 기준
          //   await this.push_appPoint(uId);
          // }

          // 회원개별발송 - 병렬 처리
          const pushPromises = this.excelUpData.map(user => {
            return this.push_appPoint(user.userId, 'PE')
              .then(() => ({ userId: user.userId, status: 'ok' }))
              .catch(err => ({ userId: user.userId, status: 'error', error: err }));
          });

          let results = await Promise.all(pushPromises);

          // 전체 결과 정리 및 에러 메시지
          let errors = results.filter(r => r.status === 'error');
          if (errors.length > 0) 
          {
            this.$swal.fire("", `푸시발송 실패회원 ${errors.length}명: ${errors.map(e => e.userId).join(', ')}`, "warning");
            console.log('발송 실패 상세:', errors);
          } 
          else 
          {
            this.$swal.fire("", "푸시이력이 등록되었습니다.", "info");
          }

          loadingAlert.close(); // 결과 표시 전에 로딩 닫기
        }
      }

      // loadingAlert.close(); // 결과 표시 전에 로딩 닫기
    },

    async push_appPoint(uId, pStyle) {
      try 
      {
        let appLinkURL = "";
        
        if(this.pushAction === "A") 
        {
          appLinkURL = "https://ntabi.co.kr/";
        } 
        else if(this.pushAction === "L") 
        {
          appLinkURL = this.puLink;
        }

        // let pushMessages = {
        //   userId: uId,
        //   title: this.puTitle,
        //   content: this.puContent,
        //   linkURL: appLinkURL,
        //   imageURL: "https://ntabi.co.kr/IMGs/pushImgs/push_ntabi.png"
        // };

        let result;
        let pushMessages = {}
        // 개별푸시(개인화푸시)
        if(pStyle == "PE") 
        {
          pushMessages = {
            userId: uId,
            title: this.puTitle,
            content: this.puContent,
            linkURL: appLinkURL,
            imageURL: "https://ntabi.co.kr/IMGs/pushImgs/push_ntabi.png"
          };
          // await로 결과값을 변수에 직접 할당
          result = await this.$api("api/pushSend01", {
            param: [{ pushMessages: pushMessages }]
          });
        }
        // 전체푸시(topic푸시이용)
        else if(pStyle == "AL") 
        {
          pushMessages = {
            topicName: uId,
            title: this.puTitle,
            content: this.puContent,
            linkURL: appLinkURL,
            imageURL: "https://ntabi.co.kr/IMGs/pushImgs/push_ntabi.png"
          };
          // await로 결과값을 변수에 직접 할당
          result = await this.$api("api/pushSendAll", {
            param: [{ pushMessages: pushMessages }]
          });

          //console.log("pushSendAll result:", result)
        }

        // // await로 결과값을 변수에 직접 할당
        // let result = await this.$api("api/pushSend01", {
        //   param: [{ pushMessages: pushMessages }]
        // });

        let arr_push = [];
        let pushHistory = [];

        // 푸싱성공->히스토리저장
        if(result == "Push successfully requested to be sent.") 
        {
          arr_push = [uId, pushMessages.title, pushMessages.content, pushMessages.linkURL, pushMessages.imageURL, pushMessages.userId, '200', 'ok', pStyle, this.puCode];
          pushHistory = await insPushHistory_man(this.$api, arr_push);
        } 
        else 
        {
          arr_push = [uId, pushMessages.title, pushMessages.content, pushMessages.linkURL, pushMessages.imageURL, pushMessages.userId, '', 'err', pStyle, this.puCode];
          pushHistory = await insPushHistory_man(this.$api, arr_push);
          
          // 실패 시 에러를 throw하여 catch에서 잡히도록
          throw new Error(`Push failed for userId: ${uId}, result: ${result}`);
        }

        if(pushHistory !== "Y") 
        {
          console.log("History Save Fail for userId:", uId);
          throw new Error(`History save failed for userId: ${uId}`);
        }

        console.log("History Save OK for userId:", uId);
        return { success: true, userId: uId }; // 성공 시 명시적 반환
      } 
      catch(error) 
      {
        console.error(`Push error for userId ${uId}:`, error);
        throw error; // 에러를 다시 던져서 상위에서 catch 가능하도록
      }
    },
  }
}
</script>